import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';

const FAQPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Generate FAQ structured data for SEO
  const generateFAQStructuredData = () => {
    const faqs = [];
    for (let i = 0; i < 16; i++) {
      faqs.push({
        "@type": "Question",
        "name": t(`faq.questions.${i}.question`),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t(`faq.questions.${i}.answer`)
        }
      });
    }

    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs
    };
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f3f4f6',
      padding: '2rem 1rem'
    }}>
      <Helmet>
        <title>Veelgestelde Vragen over Qwixx Online | FAQ Qwixx Spelregels</title>
        <meta name="description" content="Veelgestelde vragen over Qwixx Online - vind antwoorden over spelregels, klassement, leaderboard, puntentelling en hoe je met vrienden speelt. Alles wat je moet weten over Qwixx!" />
        <meta name="keywords" content="veelgestelde vragen qwixx, veelgestelde vragen qwixx online, qwixx faq, qwixx spelregels, qwixx klassement, qwixx leaderboard, hoe speel je qwixx, qwixx puntentelling, qwixx strategie, qwixx online help, qwixx online gids" />
        <link rel="canonical" href="https://qwixx-online.nl/faq" />

        {/* FAQ Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(generateFAQStructuredData())}
        </script>
      </Helmet>

      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        padding: '2rem'
      }}>
        {/* Header */}
        <div style={{
          borderBottom: '2px solid #e5e7eb',
          paddingBottom: '1.5rem',
          marginBottom: '2rem'
        }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '0.5rem',
            textAlign: 'center'
          }}>
            {t('faq.title')}
          </h1>
          <p style={{
            fontSize: '1rem',
            color: '#6b7280',
            textAlign: 'center'
          }}>
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {Array.from({ length: 16 }, (_, i) => (
            <div key={i} style={{
              padding: '1.5rem',
              backgroundColor: '#f9fafb',
              borderRadius: '0.5rem',
              borderLeft: '4px solid #3b82f6'
            }}>
              <h2 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '0.75rem'
              }}>
                {t(`faq.questions.${i}.question`)}
              </h2>
              <p style={{
                fontSize: '1rem',
                color: '#4b5563',
                lineHeight: '1.6',
                whiteSpace: 'pre-line'
              }}>
                {t(`faq.questions.${i}.answer`)}
              </p>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div style={{
          marginTop: '3rem',
          padding: '2rem',
          backgroundColor: '#eff6ff',
          borderRadius: '0.5rem',
          textAlign: 'center'
        }}>
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '1rem'
          }}>
            {t('faq.cta.title')}
          </h3>
          <p style={{
            fontSize: '1rem',
            color: '#4b5563',
            marginBottom: '1.5rem'
          }}>
            {t('faq.cta.description')}
          </p>
          <button
            onClick={() => navigate('/')}
            style={{
              backgroundColor: '#3b82f6',
              color: 'white',
              padding: '0.75rem 2rem',
              borderRadius: '0.5rem',
              border: 'none',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            {t('faq.cta.button')}
          </button>
        </div>

        {/* Back Button */}
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: '#3b82f6',
              fontSize: '1rem',
              cursor: 'pointer',
              textDecoration: 'underline'
            }}
          >
            ← {t('common.backToHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
